module.exports = __webpack_public_path__ + "img/more-black.b67ac29f.svg";